<div class="content">
    <div class="d-flex mb-2" style="align-items: center; justify-content: space-between">
        <span>{{'History' | translate}}</span>
        <a *ngIf="csvData" csvLink [data]="csvData">{{"Export as CSV" | translate}}</a>
    </div>
    <div *ngFor="let auditTrail of auditTrails; trackById" class="card inner-shadow">
        <div class="card-body">
            <p class="title text-left">{{ checkLength(auditTrail?.title) | translate }} {{annotName}} - {{
                auditTrail?.created_at | date:'dd/MM/yyyy HH:mm:ss' }}</p>
            <div class="d-flex flex-row align-items-center">
                <div class="description">
                    <div class="d-flex flex-row">
                        <table>
                            <tr>
                                <th>{{'Username' | translate}}</th>
                                <td>{{auditTrail?.user?.fullname}}</td>
                            </tr>
                            <tr>
                                <th>{{'Role' | translate}}</th>
                                <ng-container *ngIf="auditTrail?.user?.roles[0]; let role">
                                    <td>{{(role === 'SuperAdmin' ? 'Maintainer' : role) | translate}}</td>
                                </ng-container>
                            </tr>
                            <tr>
                                <th>{{'Email' | translate}}</th>
                                <td>{{auditTrail?.user?.email}}</td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="avatar"
                    [style.backgroundImage]="auditTrail?.user?.avatar ? 'url(' + auditTrail?.user?.avatar.url_small || auditTrail?.user?.avatar.url + ')' : 'url(/assets/images/avatar.svg)'">
                </div>
            </div>
        </div>
    </div>
</div>